export default __webpack_public_path__ + "static/media/bottom.eaa9d5af.png";